<template>
  <div class="icon">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <path
        class="arrow"
        d="M5.2 54c-2.4-1.2-3.3-4.1-2-6.5.5-.9 1.2-1.6 2-2L91.1.5c2.4-1.2 5.3-.3 6.5 2 .4.7.5 1.5.5 2.2v89.9c0 2.7-2.2 4.8-4.8 4.8-.8 0-1.5-.2-2.2-.5L5.2 54z" />
    </svg>
  </div>
</template>
